import { produce } from "immer";
import ACTIONS from "../actions/types.actions";

const featureFlag = produce((draft, action) => {
  switch (action.type) {
    case ACTIONS.FEATURE_FLAG_REQUEST:
      draft[action.key] = true;
      return draft;
    case ACTIONS.FEATURE_FLAG_SUCCESS:
      draft[action.key] = false;
      if (action.key === "loading") {
        draft.error = null;
        draft.value = action.response;
      } else {
        draft.mutationError = null;
      }
      return draft;
    case ACTIONS.FEATURE_FLAG_LIST_SUCCESS:
      draft.loading = false;
      draft.error = null;
      draft.list = action.response;
      draft.loaded = true;
      return draft;
    case ACTIONS.FEATURE_FLAG_LIST_ERROR:
      draft.loading = false;
      draft.error = action.error;
      draft.value = action.response;
      draft.loaded = true;
      return draft;
    case ACTIONS.FEATURE_FLAG_ERROR:
      draft[action.key] = false;
      if (action.key === "loading") {
        draft.error = action.error;
      } else {
        draft.mutationError = action.error;
      }
      return draft;
    default:
      return draft;
  }
});

export default featureFlag;
